export default __webpack_public_path__ + "a4cc43b22bf3471a0286a4b2612c809a.jpg";